import * as crypto from 'node:crypto';

export class EncryptionOperation
{
    private static encrypt<T>(algorithm: string, secret: string, message: T): string
    {
        if (secret.length != 32)
            throw new Error("Secret length must be exactly 32");
        const secretBytes = Buffer.from(secret);
        const iv = crypto.randomBytes(16);
        const cipher = crypto.createCipheriv(algorithm, secretBytes, iv);
        const encrypted = Buffer.concat([cipher.update(JSON.stringify(message), 'utf8'), cipher.final()]);
        const authTag = (cipher as any).getAuthTag();
        const ivHex = iv.toString('hex');
        const authTagHex = authTag.toString('hex');
        const encryptedHex = encrypted.toString('hex');
        return [ivHex, authTagHex, encryptedHex].join(";");
    }
    private static decrypt<T>(algorithm: string, secret: string, message: string): T
    {
        const [ivHex, authTagHex, encryptedHex] = message.split(';');
        const iv = Buffer.from(ivHex, 'hex');
        const authTag = Buffer.from(authTagHex, 'hex');
        const encrypte = Buffer.from(encryptedHex, 'hex');

        const decipher = crypto.createDecipheriv(algorithm, secret, iv);
        (decipher as any).setAuthTag(authTag);

        let decrypted = decipher.update(encrypte);
        decrypted = Buffer.concat([decrypted, decipher.final()]);
        return JSON.parse(decrypted.toString());
    }
    static AES256GCMEncrypt<T>(secret: string, message: T): string
    {
        return EncryptionOperation.encrypt("aes-256-gcm", secret, message);
    }
    static AES256GCMDecrypt<T>(secret: string, message: string): T
    {
        return EncryptionOperation.decrypt("aes-256-gcm", secret, message);
    }
}